import {Record} from "immutable";
import {ApplicationState} from "../../reducer";

const getDividerCollapsedByName = (state: Record<ApplicationState>, divider: string): boolean => !!state.getIn(['inspectioSidebar', 'sidebar', 'dividers', divider]);

export const makeDividerCollapsedByNameSelector = (divider: string): (state: Record<ApplicationState>) => boolean => (state: Record<ApplicationState>) => getDividerCollapsedByName(state, divider);
